// extracted by mini-css-extract-plugin
module.exports = {"item":"CloseIcon_item__riutx"};